import { render, staticRenderFns } from "./IDFinder.vue?vue&type=template&id=3dd87087&scoped=true"
import script from "./IDFinder.vue?vue&type=script&lang=js"
export * from "./IDFinder.vue?vue&type=script&lang=js"
import style0 from "./IDFinder.vue?vue&type=style&index=0&id=3dd87087&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd87087",
  null
  
)

export default component.exports